import React, {useEffect, useState} from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import Layout from '../components/Layout';
import {api} from '../../api';


const STATUSES = [
  'WAITING_TO_SHELF',
  'ON_SHELF',
  'PICKED',
  'PENDING_SHIPPING',
  'SHIPPED',
  'DISCARDED',
];

const AVAILABILITIES = [
  'AVAILABLE',
  'ON_HOLD',
  'SOLD',
  'BACKORDERED',
  'SPOILED',
];

export default function AddInventory() {
  const { id: itemId } = useParams();
  const navigate = useNavigate();
  const [entry, setEntry] = useState({ shelfLocation: '', status: 'WAITING_TO_SHELF', availability: 'AVAILABLE', size: '', unitId: '' });
  const [units, setUnits] = useState([]);

  useEffect(() => {
    api(`/units`).then(res => res.json()).then(setUnits).catch(() => {});
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    api(`/items/${itemId}/inventory`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ ...entry, unitId: entry.unitId || undefined, availability: entry.availability || undefined }),
    })
      .then(res => res.json())
      .then(() => navigate(`/inventory/items/${itemId}`));
  };

  return (
    <Layout>
      <div className="bg-white rounded-lg shadow p-6">
            <h1 className="text-2xl font-bold text-gray-900 mb-6">Add Inventory</h1>
            <form onSubmit={handleSubmit}>
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-1">Shelf Location</label>
                <input
                  type="text"
                  value={entry.shelfLocation}
                  onChange={(e) => setEntry({ ...entry, shelfLocation: e.target.value })}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-600"
                />
              </div>
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-1">Unit</label>
                <select
                  value={entry.unitId}
                  onChange={(e) => setEntry({ ...entry, unitId: e.target.value })}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-600"
                >
                  <option value="">— None —</option>
                  {units.map(u => <option key={u.id} value={u.id}>{u.name}</option>)}
                </select>
              </div>
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-1">Size</label>
                <input
                  type="text"
                  value={entry.size}
                  onChange={(e) => setEntry({ ...entry, size: e.target.value })}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-600"
                />
              </div>
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-1">Status</label>
                <select
                  value={entry.status}
                  onChange={(e) => setEntry({ ...entry, status: e.target.value })}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-600"
                >
                  {STATUSES.map(s => (
                    <option key={s} value={s}>{s.replace(/_/g, ' ')}</option>
                  ))}
                </select>
              </div>
              <div className="mb-6">
                <label className="block text-sm font-medium text-gray-700 mb-1">Availability</label>
                <select
                  value={entry.availability}
                  onChange={(e) => setEntry({ ...entry, availability: e.target.value })}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-600"
                >
                  {AVAILABILITIES.map(a => (
                    <option key={a} value={a}>{a.replace(/_/g, ' ')}</option>
                  ))}
                </select>
              </div>
              <div className="flex gap-3">
                <button type="submit" className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700">
                  Save
                </button>
                <button type="button" onClick={() => navigate(`/inventory/items/${itemId}`)} className="px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50">
                  Cancel
                </button>
              </div>
            </form>
      </div>
    </Layout>
  );
}
